import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import { IStore } from '../interfaces/Store'
import { STATUS } from '../enums/common'
import { IStepProps, IUseStepForm } from '../interfaces/Step'
import { IFormData } from '../interfaces/Folder'
import kycCore, { saveFolder } from '../services/Kyc'
import { breadcrumbActions } from '../store/slices/Breadcrumb'
import { loadingActions } from '../store/slices/Loading'
import { ROUTES } from '../enums/routes'
import { folderActions } from '../store/slices/Folder'
import useStepHook from './useStepHook'
import { IBreadCrumb } from '../interfaces/Breadcrumb'
import {
  getUpdatedBreadcrumb,
  handleError,
  isGeneralError,
} from '../services/utils'

const useStepFormHook = (props: IStepProps): IUseStepForm => {
  const form = useForm({ mode: 'onBlur' })
  let { step } = props
  const dispatch = useDispatch()
  const history = useHistory()
  const { getNextStep, isLastStep } = useStepHook()

  const status: string = useSelector(
    (state: IStore) => state.loadingReducer.status
  )

  const isMediumOrLowRisk: boolean = useSelector(
    (state: IStore) => state.folderReducer.isMediumOrLowRisk
  )

  const onSubmit = async (data: Record<string, any>): Promise<void> => {
    if (status === STATUS.pending) {
      return
    }
    dispatch(loadingActions.loading())
    const { action, ...inputData } = data
    try {
      const breadcrumbs = await getBreadCrumbs()
      if (data.existing_fiscal_periodique === '1' && !isLastStep()) {
        step += 1
      }

      const formData: IFormData = {
        data: inputData,
        step,
        next_step: getNextStep(breadcrumbs),
      }

      await saveFolder(formData)

      if (
        isLastStep() ||
        data.existing_fiscal_periodique === '1' ||
        (breadcrumbs && breadcrumbs.every((item) => item.visited))
      ) {
        dispatch(folderActions.folderStatusIdle())
        history.push(ROUTES.confirmationPage)
      } else {
        dispatch(breadcrumbActions.changeStep(formData.next_step))
      }
      dispatch(folderActions.folderReceived(formData.data))

      await getBreadCrumbs()
      dispatch(loadingActions.loaded())
    } catch (e) {
      if (!isGeneralError(e.message)) {
        dispatch(folderActions.saveFolderFailed(JSON.parse(e.message)))
      }
      dispatch(loadingActions.loaded())
      handleError(e, history)
    }
  }

  const onClick = (action: string) => {
    form.setValue('action', action)
  }

  const NavButtonsProps = {
    step,
    clickNext: onClick,
    clickPrev: onClick,
    isDisabled: status === STATUS.pending,
  }

  const getBreadCrumbs = async (): Promise<IBreadCrumb[]> => {
    dispatch(breadcrumbActions.breadcrumbLoading())
    try {
      const breadCrumbs = (await kycCore.breadcrumb.getBreadCrumb()) as IBreadCrumb[]
      await dispatch(
        breadcrumbActions.breadcrumbReceived(
          getUpdatedBreadcrumb(breadCrumbs, isMediumOrLowRisk)
        )
      )
      return breadCrumbs
    } catch (e) {
      dispatch(breadcrumbActions.breadcrumbLoaded())
      handleError(e, history, true)
      throw e
    }
  }

  return { form, onSubmit, NavButtonsProps }
}

export default useStepFormHook
